import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SliceState } from "./localizedApi";

const initialState: SliceState = {};

const localizedSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {
    setLocalizationIndexes: (state, action: PayloadAction<SliceState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setLocalizationIndexes } = localizedSlice.actions;

export default localizedSlice.reducer;
